module.exports = "<span class=\"heading-h5 h-gold-text\" translate> Step {{currentStep}} - {{steps.length}} </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/flow/directives/flow-indicator/flow-indicator.html
// module id = 523
// module chunks = 0